/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cognito_identity_pool_id": "ap-southeast-1:c2dddd1b-d6f1-4938-87d1-15d6893d3560",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_oaBSfXXao",
    "aws_user_pools_web_client_id": "20shc0lh7nvedv7ltq5gvk2dlr",
    "oauth": {},
    "aws_user_files_s3_bucket": "autocheckinapp-uploads121109-dev",
    "aws_user_files_s3_bucket_region": "ap-southeast-1"
};


export default awsmobile;
